import { InputNumber } from 'global/TradingModal/styled';
import { formatNumber } from 'utils/number';

function NumberInput({ value, ...props }) {
  const { min, max } = props;

  return (
    <InputNumber
      value={value}
      onKeyUp={(e) => {
        // @ts-expect-error
        let newVal = e.target.value || min;
        // @ts-expect-error
        newVal = Number(e.target.value.replace(/\D/g, ''));
        if (min && newVal < min) newVal = min;
        if (max && newVal > max) newVal = max;
        // @ts-expect-error
        // eslint-disable-next-line no-param-reassign
        e.target.value = formatNumber(newVal, false);
      }}
      {...props}
    />
  );
}

export default NumberInput;
